import { createContext, useContext } from "react";
export const AccessTokenContext = createContext(() => undefined);
export const useAccessToken = () => useContext(AccessTokenContext);
